import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { extractInboxUrlParams } from '@utils/InboxHelper';
import { DEFAULT_ITEMS_PER_PAGE } from '@utils/Pagination';

/**
 * Custom hook to manage Worker Inbox query state from URL parameters.
 * Mirrors the useMyJobsQueryState pattern — URL is the single source of truth.
 *
 * @returns Object containing urlParams, currentPage, and setSearchParams for writes
 */
export function useWorkerInboxQueryState() {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlParams = useMemo(
    () => extractInboxUrlParams(searchParams),
    [searchParams]
  );

  const currentPage = urlParams.offset
    ? Math.floor(urlParams.offset / DEFAULT_ITEMS_PER_PAGE) + 1
    : 1;

  return {
    searchParams,
    setSearchParams,
    urlParams,
    currentPage,
  };
}
